/**
 * Reusable regex patterns for validation across the application
 * Centralized location for all validation regex to ensure consistency
 */
export const VALIDATION_REGEX = {
  /**
   * Email validation pattern
   * Validates standard email format: user@example.com
   */
  EMAIL: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
  /**
   * Name validation patterns
   */
  NAME: {
    /**
     * Checks if string contains at least one Unicode letter
     */
    HAS_LETTER: /\p{L}/u,

    /**
     * Checks if string contains any digits (for rejection)
     */
    HAS_DIGIT: /\d/,

    /**
     * Only allows: letters (Unicode), combining marks, spaces, hyphens, apostrophes
     */
    VALID_CHARACTERS: /^[\p{L}\p{M}\s'-]+$/u,
  },
} as const;

/**
 * Validation error messages
 * Centralized location for consistent error messaging
 */
export const VALIDATION_MESSAGES = {
  NAME: {
    HAS_LETTER: 'must contain at least one letter',
    HAS_DIGIT: 'cannot contain numbers',
    VALID_CHARACTERS: 'can only contain letters, spaces, hyphens, and apostrophes',
  },
  EMAIL: 'Please enter a valid email address (e.g., user@example.com)',
  PHONE_US: 'Please enter a valid 10-digit US phone number',
} as const;

/**
 * Validation constraints (min/max values, lengths, etc.)
 */
export const VALIDATION_CONSTRAINTS = {
  EMAIL_MAX_LENGTH: 100,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50,
  COMPANY_MAX_LENGTH: 100,
  APARTMENT_NUMBER_MAX_LENGTH: 100,
} as const;
